<template>
  <div class="my-media reverse-mobile" id="my-media">
    <div class="row reverse-mobile">
      <div class="col-12 col-md-3">
        <UserMenu></UserMenu>
      </div>
      <div
        v-if="isLoading"
        class="w-75 d-flex position-absoloute flex-column justify-content-center align-items-center"
        style="margin-top: 295px;"
      >
        <PleaseWait></PleaseWait>
      </div>

      <div
        class="w-75 d-flex position-absoloute flex-column justify-content-center align-items-center"
        v-if="mediaCount <= 0 && !isLoading"
      >
        <NoContributed></NoContributed>
      </div>

      <div v-else class="col-sm col-md-9 col-lg-9 media-scroll-page">
        <div class="row d-flex justify-content-between mx-2">
          <div class="row mb-0">
            <div class="d-flex flex-row align-items-center">
              <i class="material-icons material-icons-title mr-2">perm_media</i>
              <h2 class="mt-2">My Media</h2>
            </div>
          </div>
          <div v-if="mediaCount > 0 && !isLoading" class="results-count">
            <b class="deep">({{ mediaCount }})</b>
            Media Item{{ mediaCount != 1 ? 's' : '' }} available
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div
            v-if="mediaCount > 0 && !isLoading"
            class="pagination-wrapper col-12 d-flex justify-content-end mt-0 mr-3"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
        </div>
        <div class="placeholder row">
          <MyMedia
            v-for="media in mediaObjects"
            :uuidId="media.uuid_id"
            :name="media.name"
            :signedThumbUrl="media.signed_thumb_url"
            :signedFullUrl="media.signed_full_url"
            :currentPrivacyLevel="media.privacy_level"
            :numDownloads="media.num_downloads"
            :fileSize="media.file_size"
            :tags="media.tags"
            :isProcessed="media.is_processed"
            :currentlyIsPublishable="media.is_publishable"
          ></MyMedia>
        </div>

        <div class="row d-flex justify-content-center">
          <div
            v-if="mediaCount > 0"
            class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mediaService from "../services/media.service";
import Paginate from "../components/Paginate";
import MyMedia from "../components/MyMedia";
import UserMenu from "../components/UserMenu";
import { isNull } from "util";
import MediaObject from "../objects/MediaObject";
import NoContributed from "../components/NoContributed";
import PleaseWait from "../components/PleaseWait";

export default {
  name: "MyMediaItems",
  components: {
    MyMedia,
    UserMenu,
    Paginate,
    NoContributed,
    PleaseWait
  },
  data: function() {
    return {
      isLoading: true,
      NUMBER_TO_GET: 4,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      media: [],
      mediaTags: [],
      mediaCount: 0,
      pageNum: 0,
      mediaObjects: [],
      isActive: false
    };
  },
  methods: {
    getMedia(startAt) {
      this.isLoading = true;
      this.isActive = true;
      mediaService.myMedia(startAt, this.NUMBER_TO_GET).then(data => {
        this.mediaCount = data.total;
        this.mediaObjects = [];
        for (let media in data.media) {
          this.mediaObjects.push(new MediaObject(data.media[media]));
        }
        this.from = parseInt(data.from);
        this.to = parseInt(data.to);
        this.updatePageCount();
        this.isLoading = false;
      });

      this.isActive = false;
    },

    clickCallback: function(pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.mediaObjects = [];
      this.getMedia(this.NUMBER_TO_GET * pageNum);
    },

    updatePageCount() {
      this.pageCount = Math.ceil(this.mediaCount / this.NUMBER_TO_GET);
    }
  },

  beforeMount() {
    this.isLoading = true;
    this.getMedia();
  }
};
</script>

<style scoped>
.placeholder {
  z-index: 9;
  margin-bottom: 30px;
}

.media {
  min-height: 350px;
}
.media {
  overflow: hidden;
}
@media (min-width: 992px) {
  .media-scroll-page {
  }
}
.lds-grid {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absoloute;
  top: 0;
  left: 0;
  right: 0;
}
.lds-grid div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #CB2E37;
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 6px;
  left: 6px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 6px;
  left: 26px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 6px;
  left: 45px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 26px;
  left: 6px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 26px;
  left: 26px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 26px;
  left: 45px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 45px;
  left: 6px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 45px;
  left: 26px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 45px;
  left: 45px;
  animation-delay: -1.6s;
}

.media-elements li i {
  margin-right: 5px;
}

.media-elements {
  height: 50px;
  background-attachment: #CB2E37;
}

@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.results-count {
  color: #6c757d;
  font-size: 14px;
}

.deep {
  color: #CB2E37;
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .pagination-wrapper {
    margin: 0px !important;
    padding: 0px !important;
    display: flex;
  }
  .pagination-wrapper ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
</style>
